import type { PartnerLedgerEntry } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

/**
 * Asset types supported by the ledger API
 */
export type AssetType =
  | 'addressBooks'
  | 'addresses'
  | 'augmentationSets'
  | 'carrierAccounts'
  | 'carrierRates'
  | 'carrierRateSets'
  | 'carrierSettings'
  | 'contacts'
  | 'contracts'
  | 'fulfillmentContexts'
  | 'fulfillmentContextLinkProperty'
  | 'injectionSites'
  | 'injectionProfiles'
  | 'labelAugmentations'
  | 'labelProperties'
  | 'lanes'
  | 'laneSortConfigurations'
  | 'limits'
  | 'origins'
  | 'packaging'
  | 'packagingSets'
  | 'postalCodeMappings'
  | 'returnsSettings'
  | 'returnToAddressOverrides'
  | 'rules'
  | 'schedules'
  | 'tags'
  | 'thirdPartyBillingAccounts'
  | 'thirdPartyBillingAccountSets'
  | 'shipOptions'
  | 'users';

export const ledger = {
  /**
   * Get ledger history for a specific asset
   */
  get: {
    queryKey: 'partner-management-service/ledger',
    configurationType: 'no-cache' as const,
    fn: async (assetType: AssetType, assetId: string): Promise<PartnerLedgerEntry> => {
      const { data } = await GatewayAxiosClient.get<PartnerLedgerEntry>(
        `/partner-management-proxy/api/v1/partners/ledger/${assetType}/${assetId}`,
      );

      return data;
    },
  },
};
